/** @jsx jsx */
import { css, jsx } from "@emotion/core"

import React, { useState } from "react"
import { IRecord } from "../../types/schema"
import { useAsyncEffect } from "../../hooks/useAsyncEffect"
import { Fields, Form2 } from "@cd2/forms"
import { useGlobalState } from "../GlobalStateProvider"

type IQuote = IRecord<"quotes", "identifier"> & { branchName: string }

export function QuotesSelectList({
  value,
  onChange,
  disabled,
  error,
  required,
  branchId,
  isClearable,
}: {
  value?: string
  onChange(id: string, project: IQuote): void
  disabled?: boolean
  error?: string
  required?: boolean
  isClearable?: boolean
  branchId?: string
}) {
  const skeem = window.skeem
  const { currentUser } = useGlobalState()
  const [query, setQuery] = useState("")

  const [quotes, setQuotes] = useState<IQuote[]>([])

  function handleChange(id: string) {
    console.log(id)
    onChange(id, quotes.find(w => w.id === id)!)
  }

  useAsyncEffect(async () => {
    const quotes = await skeem.fetch2<IQuote[]>({
      model: {
        name: "quotes",
        attributes: ["identifier", { as: "branchName", value: { path: ["branch", "name"] } }],
        filter: {
          matches: {
            branch: { or: currentUser.accessibleBranches.map(v => v.id) },
            identifier: { like: query },
          },
        },
        sort: { by: "created_at", direction: "desc" },
        paginate: { size: 30 },
      },
    })
    setQuotes(quotes)
  }, [branchId, query])

  if (quotes.length === 0 && !query) {
    return <div>Loading</div>
  }

  const accountRefCss = css`
    font-size: 12px;
    font-weight: 600;
    color: #999;
  `

  return (
    <Fields.Select2
      label={<Form2.FieldLabel fieldName="quote" label="Quote" required={required} />}
      options={quotes}
      onChange={value => handleChange(value?.id)}
      value={quotes.find(v => v.id === value)}
      getOptionLabel={opt => opt.identifier}
      getOptionValue={opt => opt.id}
      disabled={disabled}
      error={error}
      isClearable={isClearable}
      onInputChange={setQuery}
      inputValue={query}
      components={{
        SingleValue: props => {
          const { innerProps, getStyles } = props
          const lead = props.data

          return (
            <div
              {...innerProps}
              style={{
                ...getStyles("singleValue", props),
              }}
            >
              <div>{lead?.identifier}</div>
              <div css={accountRefCss}>{lead?.branchName}</div>
            </div>
          )
        },
        Option: props => {
          const { innerProps, innerRef, getStyles } = props
          const lead = props.data as IQuote

          return (
            <div
              ref={innerRef}
              {...innerProps}
              style={{
                ...getStyles("option", props),
              }}
            >
              <div>{lead?.identifier}</div>
              <div css={accountRefCss}>{lead?.branchName}</div>
            </div>
          )
        },
      }}
    />
  )
}
